<div class="guard-operations" [class.workspace-visible]="workspaceExpanded" [class.manager-access]="isManagerAccess()">
  @if (pointSelectionActive) {
    <aside class="map-pick-banner" role="status">
      <span class="map-pick-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg>
      </span>
      <span><strong>Marca el punto del registro</strong><small>Haz clic sobre el lugar exacto en el mapa. También intentaremos identificar el elemento.</small></span>
      <button type="button" (click)="cancelPointSelection()">Cancelar</button>
    </aside>
  } @else if (!workspaceExpanded && (incidentsSummaryVisible || maintenanceSummaryVisible)) {
    <section class="summary-cards" [class.single-card]="incidentsSummaryVisible !== maintenanceSummaryVisible" aria-label="Resúmenes de actividad de campo">
      @if (incidentsSummaryVisible) {
        <article class="summary-card incidents-card">
          <header>
            <div>
              <span class="eyebrow">Seguimiento</span>
              <h2>Avisos e incidencias</h2>
            </div>
            <div class="summary-card-actions">
              <button class="text-action" type="button" (click)="openView('incidents')">Ver todas</button>
              <button class="summary-close" type="button" (click)="closeSummary('incidents')" aria-label="Cerrar avisos e incidencias">×</button>
            </div>
          </header>

          @if (eventsLoading) {
            <p class="summary-state">Cargando actividad…</p>
          } @else if (eventsError) {
            <p class="summary-state error">{{ eventsError }}</p>
          } @else if (!operationalEvents.length) {
            <div class="empty-summary">
              <span>No hay incidencias registradas.</span>
              @if (!isManagerAccess()) {
                <button type="button" (click)="openView('incidents'); showIncidentForm()">Crear la primera</button>
              }
            </div>
          } @else {
            <div class="summary-list">
              @for (event of operationalEvents.slice(0, 3); track event.id) {
                <button class="summary-row" type="button" (click)="openView('incidents')">
                  <span class="summary-row-copy">
                    <strong>{{ event.title }}</strong>
                    <small>{{ getElementLabel(event.elementType, event.elementId) }}</small>
                  </span>
                  <span class="priority-badge" [class]="'priority-badge priority-' + event.priority.toLowerCase()">
                    {{ getPriorityLabel(event.priority) }}
                  </span>
                  <time>{{ formatDate(event.createdAt) }}</time>
                </button>
              }
            </div>
          }

          <footer>
            <span><strong>{{ openIncidentCount }}</strong> abiertas o en curso</span>
            @if (!isManagerAccess()) {
              <button class="compact-action" type="button" (click)="openView('incidents'); showIncidentForm()">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                Nueva incidencia
              </button>
            }
          </footer>
        </article>
      }
      @if (maintenanceSummaryVisible) {
        <article class="summary-card maintenance-card">
          <header>
            <div>
              <span class="eyebrow">Mantenimiento</span>
              <h2>Escuras</h2>
            </div>
            <div class="summary-card-actions">
              <button class="text-action" type="button" (click)="openView('maintenance')">Ver escuras</button>
              <button class="summary-close" type="button" (click)="closeSummary('maintenance')" aria-label="Cerrar escuras">×</button>
            </div>
          </header>

          @if (maintenanceLoading) {
            <p class="summary-state">Cargando escuras…</p>
          } @else if (maintenanceError) {
            <p class="summary-state error">{{ maintenanceError }}</p>
          } @else if (!maintenanceEntries.length) {
            <div class="empty-summary">
              <span>Todavía no hay escuras registradas.</span>
              @if (!isManagerAccess()) {
                <button type="button" (click)="openView('maintenance'); showMaintenanceForm()">Añadir escura</button>
              }
            </div>
          } @else {
            <div class="summary-list">
              @for (entry of maintenanceEntries.slice(0, 3); track entry.id) {
                <button class="summary-row maintenance-row" type="button" (click)="openView('maintenance')">
                  <span class="entry-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M7 3h10a2 2 0 0 1 2 2v16H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>
                  </span>
                  <span class="summary-row-copy">
                    <strong>{{ entry.isMaintenanceCompleted ? 'Escura realizada' : (entry.execution ? 'Escura ejecutada' : 'Pendiente de ejecución') }}</strong>
                    <small>{{ getElementLabel(entry.elementType, entry.elementId) }}</small>
                  </span>
                  <time>{{ formatDate(entry.inspectionEffectiveAt) }}</time>
                </button>
              }
            </div>
          }

          <footer>
            <span><strong>{{ maintenanceEntries.length }}</strong> escuras recientes</span>
            @if (!isManagerAccess()) {
              <button class="compact-action" type="button" (click)="openView('maintenance'); showMaintenanceForm()">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" /></svg>
                Nueva escura
              </button>
            }
          </footer>
        </article>
      }
    </section>
  } @else if (workspaceExpanded) {
    <section class="workspace-panel" role="dialog" aria-modal="false" [attr.aria-labelledby]="currentView + '-title'">
      <header class="workspace-header">
        <div class="workspace-heading">
          <span class="workspace-icon" [class.maintenance]="currentView === 'maintenance'" aria-hidden="true">
            @if (currentView === 'incidents') {
              <svg viewBox="0 0 24 24"><path d="M12 3 2.8 19h18.4L12 3Z" /><path d="M12 9v4M12 17h.01" /></svg>
            } @else {
              <svg viewBox="0 0 24 24"><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>
            }
          </span>
          <div>
            <span class="eyebrow">{{ isManagerAccess() ? 'Supervisión operativa' : 'Trabajo de campo' }}</span>
            <h2 [id]="currentView + '-title'">
              {{ currentView === 'incidents' ? 'Avisos e incidencias' : 'Escuras' }}
            </h2>
            <p>
              {{ currentView === 'incidents'
                ? (isManagerAccess()
                  ? 'Consulta los registros de los guardas y actualiza su estado de seguimiento.'
                  : 'Registra problemas y consulta su estado de seguimiento.')
                : (isManagerAccess()
                  ? 'Consulta las inspecciones y ejecuciones de escuras registradas por los guardas.'
                  : 'Inspecciona las escuras y registra su ejecución cuando sea necesaria.') }}
            </p>
          </div>
        </div>
        <button class="close-button" type="button" (click)="closeView()" aria-label="Cerrar panel">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </header>

      @if (feedbackMessage) {
        <div class="feedback" role="status">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6" /></svg>
          {{ feedbackMessage }}
          <button type="button" (click)="feedbackMessage = ''" aria-label="Cerrar confirmación">×</button>
        </div>
      }
      @if (statusUpdateError) {
        <div class="feedback error-feedback" role="alert">
          {{ statusUpdateError }}
          <button type="button" (click)="statusUpdateError = ''" aria-label="Cerrar error">×</button>
        </div>
      }

      @if (currentView === 'incidents') {
        <div class="workspace-toolbar" [class.read-only-toolbar]="isManagerAccess()">
          <label class="search-control">
            <span class="sr-only">Buscar avisos o incidencias</span>
            <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></svg>
            <input type="search" [(ngModel)]="incidentSearch" placeholder="Buscar por título, detalle o toma…" />
          </label>
          <label class="filter-control">
            <span>Tipo</span>
            <select [(ngModel)]="incidentTypeFilter">
              <option value="all">Todos</option>
              <option value="Incident">Incidencias</option>
              <option value="Notice">Avisos</option>
            </select>
          </label>
          <label class="filter-control">
            <span>Estado</span>
            <select [(ngModel)]="incidentStatusFilter">
              <option value="all">Todos</option>
              <option value="Open">Abiertas</option>
              <option value="InProgress">En curso</option>
              <option value="Resolved">Resueltas</option>
              <option value="Cancelled">Canceladas</option>
            </select>
          </label>
          @if (!isManagerAccess()) {
            <button class="primary-action" type="button" (click)="showIncidentForm()">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
              Nueva incidencia
            </button>
          }
        </div>

        <div class="workspace-content">
          <div class="section-summary">
            <div><strong>{{ visibleOperationalEvents.length }}</strong><span>resultados</span></div>
            <div><strong>{{ openIncidentCount }}</strong><span>requieren atención</span></div>
          </div>

          @if (eventsLoading) {
            <div class="large-state"><span class="spinner"></span><p>Cargando avisos e incidencias…</p></div>
          } @else if (eventsError) {
            <div class="large-state error"><p>{{ eventsError }}</p></div>
          } @else if (!visibleOperationalEvents.length) {
            <div class="large-state">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 2.8 19h18.4L12 3Z" /><path d="M12 9v4M12 17h.01" /></svg>
              <p>No hay resultados con los filtros seleccionados.</p>
            </div>
          } @else {
            <div class="record-list">
              @for (event of visibleOperationalEvents; track event.id) {
                <article class="record-card incident-record">
                  <div class="record-marker" [class]="'record-marker priority-' + event.priority.toLowerCase()" aria-hidden="true"></div>
                  <div class="record-main">
                    <div class="record-topline">
                      <span class="type-label">{{ getEventTypeLabel(event.type) }} #{{ event.id }}</span>
                      <span class="status-badge" [class]="'status-badge status-' + event.status.toLowerCase()">
                        {{ getStatusLabel(event.status) }}
                      </span>
                    </div>
                    <h3>{{ event.title }}</h3>
                    @if (event.description) { <p>{{ event.description }}</p> }
                    <div class="record-meta">
                      <span>
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12c3-5 8-5 11-2" /><path d="M13 5h6v6M19 5l-7 7" /></svg>
                        {{ getElementLabel(event.elementType, event.elementId) }}
                      </span>
                      <span>
                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                        {{ formatDate(event.createdAt) }}
                      </span>
                      @if (event.geometry) {
                        <span title="Coordenadas ETRS89 / UTM 30N">
                          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg>
                          {{ formatPoint(event.geometry) }}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="record-actions">
                    <span class="priority-badge" [class]="'priority-badge priority-' + event.priority.toLowerCase()">
                      {{ getPriorityLabel(event.priority) }}
                    </span>
                    @if (isManagerAccess()) {
                      <label class="status-editor">
                        <span>Estado</span>
                        <select
                          [value]="event.status"
                          [disabled]="statusSavingEventId !== undefined"
                          [attr.aria-label]="'Cambiar estado de ' + event.title"
                          (change)="updateOperationalEventStatus(event, $any($event.target))"
                        >
                          <option value="Open">Abierta</option>
                          <option value="InProgress">En curso</option>
                          <option value="Resolved">Resuelta</option>
                          <option value="Cancelled">Cancelada</option>
                        </select>
                      </label>
                      @if (isMaintenanceDateCorrectionIncident(event)) {
                        <button class="text-action" type="button" (click)="showManagerDateCorrectionForm(event)">Aplicar corrección de fecha</button>
                      }
                    }
                  </div>
                </article>
              }
            </div>
          }
        </div>
      } @else {
        <div class="workspace-toolbar maintenance-toolbar" [class.read-only-toolbar]="isManagerAccess()">
          <label class="search-control">
            <span class="sr-only">Buscar escuras</span>
            <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></svg>
            <input type="search" [(ngModel)]="maintenanceSearch" placeholder="Buscar por observaciones, estado o elemento…" />
          </label>
          @if (!isManagerAccess()) {
            <button class="primary-action" type="button" (click)="showMaintenanceForm()">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" /></svg>
              Nueva escura
            </button>
          }
        </div>

        <div class="workspace-content">
          <div class="section-summary">
            <div><strong>{{ visibleMaintenanceEntries.length }}</strong><span>escuras</span></div>
            <div>
              <strong>{{ isManagerAccess() ? maintenanceEntries.length : takes.length }}</strong>
              <span>{{ isManagerAccess() ? 'inspecciones cargadas' : 'tomas disponibles' }}</span>
            </div>
          </div>

          @if (maintenanceLoading) {
            <div class="large-state"><span class="spinner"></span><p>Cargando escuras…</p></div>
          } @else if (maintenanceError) {
            <div class="large-state error"><p>{{ maintenanceError }}</p></div>
          } @else if (!visibleMaintenanceEntries.length) {
            <div class="large-state">
              <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>
              <p>No hay escuras que coincidan con la búsqueda.</p>
            </div>
          } @else {
            <div class="record-list maintenance-record-list">
              @for (entry of visibleMaintenanceEntries; track entry.id) {
                <article class="record-card maintenance-record">
                  <div class="record-marker" [class]="'record-marker ' + (entry.isMaintenanceCompleted || entry.execution ? 'priority-low' : 'priority-high')" aria-hidden="true"></div>
                  @if (entry.imageUrl) {
                    <a class="maintenance-photo-link" [href]="entry.imageUrl" target="_blank" rel="noopener noreferrer" aria-label="Abrir fotografía de la inspección">
                      <img class="maintenance-photo" [src]="entry.imageUrl" alt="Fotografía de la inspección de escura" />
                    </a>
                  }
                  <div class="record-main">
                    <div class="record-topline">
                      <span class="type-label">Inspección de escura #{{ entry.id }}</span>
                      <span class="status-badge" [class.status-resolved]="entry.isMaintenanceCompleted || entry.execution" [class.status-open]="!entry.isMaintenanceCompleted && !entry.execution">
                        {{ entry.isMaintenanceCompleted ? 'Ya realizada' : (entry.execution ? 'Ejecutada por el guarda' : 'Pendiente de ejecución') }}
                      </span>
                    </div>
                    <h3>{{ getElementLabel(entry.elementType, entry.elementId) }}</h3>
                    @if (entry.observations) { <p>{{ entry.observations }}</p> }
                    <div class="record-meta">
                      <span>
                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                        Inspección: {{ formatDate(entry.inspectionEffectiveAt) }}
                      </span>
                      <span title="Coordenadas ETRS89 / UTM 30N">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg>
                        {{ formatPoint(entry.geometry) }}
                      </span>
                    </div>
                    @if (entry.execution) {
                      <div class="maintenance-execution">
                        <strong>Ejecución</strong>
                        <span>{{ entry.execution.durationMinutes }} min</span>
                        <span>{{ entry.execution.backpackQuantity }} mochila</span>
                        <time>{{ formatDate(entry.execution.effectiveAt) }}</time>
                      </div>
                    }
                  </div>
                  @if (!isManagerAccess()) {
                    <div class="record-actions">
                      @if (!entry.isMaintenanceCompleted && !entry.execution) {
                        <button class="primary-action" type="button" (click)="showExecutionForm(entry)">Registrar ejecución</button>
                      }
                      <button class="text-action" type="button" (click)="showDateCorrectionForm(entry, 'inspection')">Corregir fecha de inspección</button>
                      @if (entry.execution) {
                        <button class="text-action" type="button" (click)="showDateCorrectionForm(entry, 'execution')">Corregir fecha de ejecución</button>
                      }
                    </div>
                  }
                </article>
              }
            </div>
          }
        </div>
      }

      @if (!isManagerAccess() && incidentFormVisible) {
        <div class="form-backdrop" (click)="dismissForms()"></div>
        <form class="entry-form" (ngSubmit)="submitIncident()" (click)="$event.stopPropagation()">
          <header>
            <div><span class="eyebrow">Nuevo registro</span><h3>Aviso o incidencia</h3></div>
            <button type="button" class="close-button" (click)="dismissForms()" aria-label="Cerrar formulario">×</button>
          </header>
          <div class="form-grid">
            <label><span>Tipo</span><select name="incidentType" [(ngModel)]="incidentDraft.type"><option value="Incident">Incidencia</option><option value="Notice">Aviso</option></select></label>
            <label><span>Prioridad</span><select name="incidentPriority" [(ngModel)]="incidentDraft.priority"><option value="Low">Baja</option><option value="Medium">Media</option><option value="High">Alta</option></select></label>
            <label class="full-width"><span>Título *</span><input name="incidentTitle" [(ngModel)]="incidentDraft.title" maxlength="150" placeholder="Ej. Obstrucción en rejilla" required /></label>
            <label><span>Tipo de elemento *</span><select name="incidentElementType" [(ngModel)]="incidentDraft.elementType" (ngModelChange)="onIncidentElementTypeChanged()"><option value="">Selecciona un tipo</option>@for (option of elementTypeOptions; track option.value) { <option [value]="option.value">{{ option.label }}</option> }</select></label>
            <label><span>Elemento concreto *</span><select name="incidentElementId" [(ngModel)]="incidentDraft.elementId" [disabled]="!incidentDraft.elementType || !incidentElementOptions.length"><option value="">{{ incidentElementOptions.length ? 'Selecciona un elemento' : (selectedMapPoint ? 'No identificado en este punto' : 'Marca un punto en el mapa') }}</option>@for (element of incidentElementOptions; track element.id) { <option [value]="element.id">{{ element.label }}</option> }</select></label>
            <div class="location-field full-width" [class.selected]="selectedMapPoint">
              <span class="location-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg></span>
              <span><strong>{{ selectedMapPoint ? 'Punto seleccionado' : 'Ubicación obligatoria' }}</strong><small>{{ selectedMapPoint ? formatMapPoint() + ' · ETRS89 / UTM 30N' : 'Marca el lugar exacto del registro.' }}</small></span>
              <span class="location-actions">
                <button type="button" (click)="startPointSelection()">{{ selectedMapPoint ? 'Cambiar punto' : 'Marcar en mapa' }}</button>
                <button type="button" class="geolocation-action" (click)="useCurrentLocation()" [disabled]="geolocationLoading">{{ geolocationLoading ? 'Localizando…' : 'Mi ubicación' }}</button>
              </span>
            </div>
            @if (geolocationError) { <p class="location-error full-width" role="alert">{{ geolocationError }}</p> }
            <label class="full-width"><span>Descripción</span><textarea name="incidentDescription" [(ngModel)]="incidentDraft.description" rows="5" placeholder="Describe qué sucede y cualquier dato útil para resolverlo"></textarea></label>
          </div>
          @if (formError) { <p class="form-error" role="alert">{{ formError }}</p> }
          <footer><button type="button" class="secondary-action" (click)="dismissForms()">Cancelar</button><button type="submit" class="primary-action" [disabled]="saving">{{ saving ? 'Registrando…' : 'Registrar' }}</button></footer>
        </form>
      }

      @if (!isManagerAccess() && maintenanceFormVisible) {
        <div class="form-backdrop" (click)="dismissForms()"></div>
        <form class="entry-form" (ngSubmit)="submitMaintenanceEntry()" (click)="$event.stopPropagation()">
          <header>
            <div><span class="eyebrow">Nueva inspección</span><h3>Inspección de escura</h3></div>
            <button type="button" class="close-button" (click)="dismissForms()" aria-label="Cerrar formulario">×</button>
          </header>
          <div class="form-grid">
            <label><span>Tipo de elemento *</span><select name="maintenanceElementType" [(ngModel)]="maintenanceDraft.elementType" (ngModelChange)="onMaintenanceElementTypeChanged()"><option value="">Selecciona un tipo</option>@for (option of elementTypeOptions; track option.value) { <option [value]="option.value">{{ option.label }}</option> }</select></label>
            <label><span>Elemento concreto *</span><select name="maintenanceElementId" [(ngModel)]="maintenanceDraft.elementId" [disabled]="!maintenanceDraft.elementType || !maintenanceElementOptions.length"><option value="">{{ maintenanceElementOptions.length ? 'Selecciona un elemento' : (selectedMapPoint ? 'No identificado en este punto' : 'Marca un punto en el mapa') }}</option>@for (element of maintenanceElementOptions; track element.id) { <option [value]="element.id">{{ element.label }}</option> }</select></label>
            <label class="full-width"><span>Resultado de la inspección *</span><select name="maintenanceCompleted" [(ngModel)]="maintenanceDraft.isMaintenanceCompleted"><option [ngValue]="true">La escura ya está realizada</option><option [ngValue]="false">La escura no está realizada</option></select></label>
            <div class="location-field full-width" [class.selected]="selectedMapPoint">
              <span class="location-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg></span>
              <span><strong>{{ selectedMapPoint ? 'Punto seleccionado' : 'Ubicación obligatoria' }}</strong><small>{{ selectedMapPoint ? formatMapPoint() + ' · ETRS89 / UTM 30N' : 'Marca el lugar exacto del registro.' }}</small></span>
              <span class="location-actions">
                <button type="button" (click)="startPointSelection()">{{ selectedMapPoint ? 'Cambiar punto' : 'Marcar en mapa' }}</button>
                <button type="button" class="geolocation-action" (click)="useCurrentLocation()" [disabled]="geolocationLoading">{{ geolocationLoading ? 'Localizando…' : 'Mi ubicación' }}</button>
              </span>
            </div>
            @if (geolocationError) { <p class="location-error full-width" role="alert">{{ geolocationError }}</p> }
            <label class="full-width"><span>Observaciones</span><textarea name="maintenanceObservations" [(ngModel)]="maintenanceDraft.observations" rows="5" placeholder="Añade cualquier detalle útil de la inspección"></textarea></label>
            <label class="full-width">
              <span>Fotografía</span>
              <input name="maintenanceImage" type="file" accept="image/jpeg,image/png,image/webp" (change)="onMaintenanceImageSelected($event)" />
              <small>{{ maintenanceImageLoading ? 'Leyendo fotografía…' : (maintenanceDraft.image?.fileName || 'Opcional · JPG, PNG o WebP · máximo 10 MB') }}</small>
            </label>
          </div>
          @if (formError) { <p class="form-error" role="alert">{{ formError }}</p> }
          <footer><button type="button" class="secondary-action" (click)="dismissForms()">Cancelar</button><button type="submit" class="primary-action" [disabled]="saving || maintenanceImageLoading">{{ saving ? 'Guardando…' : 'Guardar inspección' }}</button></footer>
        </form>
      }

      @if (!isManagerAccess() && executionFormRecordId) {
        <div class="form-backdrop" (click)="dismissForms()"></div>
        <form class="entry-form compact-entry-form" (ngSubmit)="submitMaintenanceExecution()" (click)="$event.stopPropagation()">
          <header>
            <div><span class="eyebrow">Escura pendiente</span><h3>Registrar ejecución</h3></div>
            <button type="button" class="close-button" (click)="dismissForms()" aria-label="Cerrar formulario">×</button>
          </header>
          <div class="form-grid">
            <label>
              <span>Tiempo empleado (minutos) *</span>
              <span class="numeric-stepper">
                <button type="button" (click)="adjustExecutionDuration(-15)" [disabled]="executionDurationAtMinimum" aria-label="Restar 15 minutos">−</button>
                <input name="executionDuration" type="number" min="15" step="15" inputmode="numeric" [(ngModel)]="executionDraft.durationMinutes" required />
                <button type="button" (click)="adjustExecutionDuration(15)" aria-label="Añadir 15 minutos">+</button>
              </span>
              <small>Incrementos de 15 minutos</small>
            </label>
            <label>
              <span>Mochila *</span>
              <span class="numeric-stepper">
                <button type="button" (click)="adjustBackpackQuantity(-0.25)" [disabled]="backpackQuantityAtMinimum" aria-label="Restar 0,25 de mochila">−</button>
                <input name="executionBackpack" type="number" min="0" step="0.25" inputmode="decimal" [(ngModel)]="executionDraft.backpackQuantity" required />
                <button type="button" (click)="adjustBackpackQuantity(0.25)" aria-label="Añadir 0,25 de mochila">+</button>
              </span>
              <small>Incrementos de 0,25</small>
            </label>
          </div>
          @if (formError) { <p class="form-error" role="alert">{{ formError }}</p> }
          <footer><button type="button" class="secondary-action" (click)="dismissForms()">Cancelar</button><button type="submit" class="primary-action" [disabled]="saving">{{ saving ? 'Guardando…' : 'Guardar ejecución' }}</button></footer>
        </form>
      }

      @if (!isManagerAccess() && dateCorrectionRecord) {
        <div class="form-backdrop" (click)="dismissForms()"></div>
        <form class="entry-form compact-entry-form" (ngSubmit)="submitDateCorrectionIncident()" (click)="$event.stopPropagation()">
          <header>
            <div><span class="eyebrow">Solicitud administrativa</span><h3>Corregir fecha de {{ dateCorrectionDraft.target === 'execution' ? 'ejecución' : 'inspección' }}</h3></div>
            <button type="button" class="close-button" (click)="dismissForms()" aria-label="Cerrar formulario">×</button>
          </header>
          <div class="form-grid">
            <label class="full-width"><span>Fecha y hora reales *</span><input name="correctionDate" type="datetime-local" [(ngModel)]="dateCorrectionDraft.requestedAt" required /></label>
            <label class="full-width"><span>Motivo *</span><textarea name="correctionReason" [(ngModel)]="dateCorrectionDraft.reason" rows="4" placeholder="Explica por qué no se registró la operación en el momento correcto" required></textarea></label>
          </div>
          <p class="form-help">Se creará una incidencia vinculada a esta operación. La fecha original no se modificará hasta que un administrador revise la solicitud.</p>
          @if (formError) { <p class="form-error" role="alert">{{ formError }}</p> }
          <footer><button type="button" class="secondary-action" (click)="dismissForms()">Cancelar</button><button type="submit" class="primary-action" [disabled]="saving">{{ saving ? 'Enviando…' : 'Crear incidencia' }}</button></footer>
        </form>
      }

      @if (isManagerAccess() && managerCorrectionIncident) {
        <div class="form-backdrop" (click)="dismissForms()"></div>
        <form class="entry-form compact-entry-form" (ngSubmit)="submitManagerDateCorrection()" (click)="$event.stopPropagation()">
          <header>
            <div><span class="eyebrow">Revisión administrativa</span><h3>Aplicar corrección de fecha</h3></div>
            <button type="button" class="close-button" (click)="dismissForms()" aria-label="Cerrar formulario">×</button>
          </header>
          <div class="form-grid">
            <label class="full-width"><span>Fecha y hora efectivas *</span><input name="managerCorrectionDate" type="datetime-local" [(ngModel)]="managerCorrectedAt" required /></label>
          </div>
          <p class="form-help">La fecha automática original se conservará y esta corrección quedará vinculada a la incidencia #{{ managerCorrectionIncident.id }}.</p>
          @if (formError) { <p class="form-error" role="alert">{{ formError }}</p> }
          <footer><button type="button" class="secondary-action" (click)="dismissForms()">Cancelar</button><button type="submit" class="primary-action" [disabled]="saving">{{ saving ? 'Aplicando…' : 'Aplicar corrección' }}</button></footer>
        </form>
      }
    </section>
  }
</div>
